<template>
    <div>
        <v-container>
            <v-row class="py-md-16 py-0 my-8">
                <v-col class="col-12 pb-md-16 pb-4">
                    <h2 class="text-align-center">Process</h2>
                </v-col>
                <v-col class="col-12">
                    <img src="../assets/images/details-page/increase-lead-process.jpg" width="100%"/>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="mt-md-16">
            <v-row>
                <v-col class="col-12">
                    <p class="pb-2 small-uppercase accent-color">01. Discover</p>
                    <h3 class="pb-md-2 pb-0">Quantitative Research</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <p class="grey-text-600 w500 pb-8"><span class="grey-text-100">“Why is the sales contribution from our website consistently the lowest every month?”</span> The NJOI box is available for purchase on both the official NJOI website and various e-commerce platforms.
                    <br><br>However, according to our bi-weekly data report, we have noticed that the official website consistently maintains a lower submission rate compared to other e-commerce websites.
                    <br><br>Moreover, the digital managers have raised concerns that the number of recent leads generated from the official website has decreased since December 2021.
                    </p>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-md-4">
                <v-col class="col-md-6 col-12 pa-0 pr-md-8">
                    <p class="grey-text-600 w500">On average, there has been an <span class="grey-text-100">18.9% sales contribution</span> over the past 3 months.</p>
                </v-col>
                <v-col class="col-md-6 col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-data01.png" width="100%"/>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-md-4">
                <v-col class="col-md-6 col-12 pa-0 pr-md-8">
                    <p class="grey-text-600 w500">Several data samples were selected from Hotjar to casually investigate user behavior.<br><br>We found that there is <span class="grey-text-100">a lot of drop-off on the Pack Details Page</span>.</p>
                </v-col>
                <v-col class="col-md-6 col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-data02.jpg" width="100%"/>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-md-4">
                <v-col class="col-md-6 col-12 pa-0 pr-md-8">
                    <p class="grey-text-600 w500">Based on the data, there is <span class="grey-text-100">dramatic traffic will happen whenever there is a campaign</span>.<br><br>The marketing and business team will promote the campaign package by sharing the official <span class="grey-text-100">website's Pack Details Page</span>.</p>
                </v-col>
                <v-col class="col-md-6 col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-data00.png" width="100%"/>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-md-4">
                <v-col class="col-md-6 col-12 pa-0 pr-md-8">
                    <p class="grey-text-600 w500">There are <span class="grey-text-100">2 main buttons on the Pack Details Page 'Purchase via app' and 'Find out more'</span>. 'Purchase via app' button is targeting existing customers to purchase the items in the mobile app, while the 'Find out more' button is targeting new customers to learn more about the product.
                        <br><br>Based on the past 3 months data, <span class="grey-text-100">most of the users engage with the 'Purchase via app' button</span>. This might be because of the 'Purchase via app' is the only primary button on the Pack Details Page.
                    </p>
                </v-col>
                <v-col class="col-md-6 col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-data03.png" width="100%"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <h3 class="pb-md-2 pb-0 pt-8">Competitor Analysis</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <p class="grey-text-600 w500 pb-4"><span class="grey-text-100">Several interesting sample</span> have been chosen for evaluating their Sign Up section's experience.</p>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-md-8 mb-6">
                <v-col class="col-md-12 col-12 pa-0 pr-md-8 pb-4">
                    <p class="grey-text-600 w500"><span class="grey-text-100">Most of them use a large amount of space</span> for their Sign Up section.</p>
                </v-col>
                <v-col class="col-md-12 col-12 pa-0">
                    <img src="../assets/images/details-page/increase-lead-data04.jpg" width="100%"/>
                </v-col>
            </v-row>
            <v-row class="mb-4">
                <v-col class="col-md-6 col-12">
                    <div class="card-subsection__content pa-md-16 pa-8 ma-0">
                        <p class="grey-text-600 w500 pb-4">All of the sample use a <span class="grey-text-100">primary button for Sign Up</span>.</p>
                        <!-- <img src="../assets/images/details-page/increase-lead-data05.jpg" width="100%"/>  -->
                    </div>
                </v-col>
                <v-col class="col-md-6 col-12">
                    <div class="card-subsection__content pa-md-16 pa-8 ma-0">
                    <p class="grey-text-600 w500">Some of them display <span class="grey-text-100">eye-catching images</span>, making the section more interesting.</p>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="mt-md-16">
            <v-row>
                <v-col class="col-12">
                    <p class="pb-2 small-uppercase accent-color">02. Define</p>
                    <h3 class="pb-md-2 pb-0">Problem Statement</h3>
                </v-col>
            </v-row>
            <v-row class="mb-8">
                <v-col class="col-md-6 col-12">
                    <div class="card-subsection__content pa-md-16 pa-8 ma-0">
                        <p class="grey-text-600 w500"><span class="grey-text-100">Disjointed experience on Pack Details Page</span> has been affecting the conversion rate of the NJOI website.</p>
                    </div>
                </v-col>
                <v-col class="col-md-6 col-12">
                    <div class="card-subsection__content pa-md-16 pa-8 ma-0">
                        <p class="grey-text-600 w500">We have to <span class="grey-text-100">redefine the primary action</span> that we want user to perform on the Pack Detials Page. 'Purchase via app' should be the secondary action of the page.</p><br>
                    </div>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="mt-md-16">
            <v-row>
                <v-col class="col-12">
                    <p class="pb-2 small-uppercase accent-color">03. Develop</p>
                    <h3 class="pb-md-2 pb-0">High-fidelity</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <p class="grey-text-600 w500 pb-8"><span class="grey-text-100">I have presented the ideas in high-fedility to Project Owner, Developer Team and Managers.</span> We had a meaningful discussion on how to further enhance the existing language selection user experience.
                    <br><br>I have turned the collective feedback into the action items listed below:
                    </p>
                    <ul class="grey-text-600">
                        <li>Add a looping animation with our popular channels' logo to drawn prospect's attention.</li>
                        <li>Use text button to deprioritize the 'Purchase Via My NJOI App' button.</li>
                        <li>A big section for Sign Up section.</li>
                        <li>Large buttons make it easier for user to navigate.</li>
                    </ul>
                </v-col>
            </v-row>
            <v-row class="mb-4">
                <v-col class="col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-wireframe.jpg" width="100%"/>
                </v-col>
            </v-row>
        </v-container>
        <v-container class="mt-md-16">
            <v-row>
                <v-col class="col-12">
                    <p class="pb-2 small-uppercase accent-color">04. Deliver</p>
                    <h3 class="pb-md-2 pb-0">Handover</h3>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-8">
                <v-col class="pa-0">
                    <img src="../assets/images/details-page/increase-lead-handover00.png" width="100%"/>
                    <img src="../assets/images/details-page/increase-lead-handover01.png" width="100%"/>
                    <img src="../assets/images/details-page/increase-lead-handover02.png" width="100%"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <h3 class="pb-md-2 pb-0 pt-4">Results</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="col-12">
                    <p class="grey-text-600 w500 pb-8">As a result, we <span class="grey-text-100">successfully resolved most of our UX problems</span> after launching the new design one month ago.</p>
                </v-col>
            </v-row>
            <v-row class="card-subsection__content pa-md-16 pa-8 ma-0 mb-4">
                <v-col class="col-md-6 col-12 pa-0 pr-md-8">
                    <p class="grey-text-600 w500"><span class="grey-text-100">Website contribute 41% of sales</span> and e-commerce website is 59%. The sales contribution of the website <span class="grey-text-100">increased by 22%</span> after 3 months launching. </p>
                </v-col>
                <v-col class="col-md-6 col-12 pl-md-8">
                    <img src="../assets/images/details-page/increase-lead-data06.png" width="100%"/>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'IncreasePlatformLead',
}
</script>

<style lang="scss" scoped>

    @import '../App.scss';

    .card-subsection__content {
        border: 1px solid $grey-color-800;
        background: hsla(210, 11%, 15%,.3);
        border-radius: 22px;
        height: 100%;
    }

    .lottie-frame{
        border: 1px solid $grey-color-800;
        background: white;
        border-radius: 22px;
        width: 100%;

        iframe {
            border: none;
            width: 100%;
            min-height: 300px;
        }
    }


    @media only screen and (max-width: 600px) {
    
    }
</style>


// WEBPACK FOOTER //
// src/views/IncreasePlatformLead.vue